// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "Beri Tahu Klien Untuk Dialihkan",
  "1d484fee4a": "Departemen Keuangan, Departemen Penjualan, Manajemen Proyek, Data Bisnis, Departemen Produk, Departemen Operasional, Manajemen Pengembangan, Rencana Versi, Departemen Layanan Pelanggan, Departemen Administrasi, Departemen Pengadaan, Manajemen Purna Jual",
  "a2c88dfb79": "Buat Tim Pertama Anda",
  "3cfdcc6086": "Departemen Keuangan, Departemen Penjualan, Manajemen Proyek/305, Administrasi Sumber Daya Manusia/306, Departemen Operasional, Manajemen Pengembangan, Rencana Versi, Manajemen Layanan Pelanggan/403, Departemen Pengadaan, Manajemen Purna Jual",
  "ac45ec2c05": "Verifikasi Login Akun Gagal",
  "9aef9b8ccd": "Akun Login Saat Ini Bermasalah, Silakan Login Ulang dan Coba Lagi",
  "728dd00f22": "Nomor Ponsel Ini Bermasalah, Silakan Coba Login Dengan Verifikasi SMS",
  "30dbecd916": "Informasi yang Anda Isi Mengandung Kata Sensitif, Silakan Ubah dan Coba Lagi",
  "12ed508d8a": "Anda Telah Melakukan Terlalu Banyak Operasi, Silakan Coba Lagi Nanti",
  "952d4a7595": "Status Login Akun Saat Ini Bermasalah, Silakan Login Ulang dan Coba Lagi",
  "e64bfdeaa4": "Verifikasi Login Gagal, Silakan Dapatkan Kode Verifikasi SMS Lagi",
  "79008a65f1": "Nomor Ponsel Ini Sudah Bergabung dengan Beberapa Perusahaan, Silakan Login ke Perusahaan Atau Ganti Nomor Ponsel",
  "bf242eff42": "Nama Perusahaan Sudah Ada",
  "4f0cdb8374": "Silakan Masukkan Nomor Ponsel Lengkap, Jika Anda Menggunakan Nomor Ponsel Luar Negeri, Silakan Ganti ke Nomor Dalam Negeri (86+)",
  "46e79ffeff": "Terjadi Kesalahan Saat Membuat Perusahaan, Silakan Hubungi Layanan Pelanggan Resmi",
  "f3e18f0341": "Verifikasi Parameter Gagal",
  "503fd1718d": "Gagal Mengirim Kode Verifikasi SMS",
  "24b3129f19": "Pengiriman SMS Terlalu Sering, Silakan Coba Lagi Nanti",
  "1cde3e8245": "Kode Verifikasi Salah, Silakan Masukkan Ulang",
  "4212ecc031": "Telah Beberapa Kali Verifikasi Gagal, Sementara Dibatasi, Silakan Coba Lagi Nanti",
  "735da9c347": "Verifikasi Nama Perusahaan Bermasalah, Silakan Hubungi Layanan Pelanggan Resmi",
  "8731da9615": "Verifikasi Nama Perusahaan Bermasalah, Silakan Hubungi Layanan Pelanggan Resmi",
  "62e89b3f16": "Setujui Perjanjian Layanan",
  "c9b79027e5": "Kirimkan Kode Verifikasi",
  "84c1447b9d": "Berhasil disalin",
  "fba4b0abd0": "Catatan Host",
  "37f5a7cd41": "Nilai TXT",
  "78b12427c9": "Sedang Verifikasi...",
  "59d089837c": "Kami Saat Ini Tidak Dapat Memverifikasi Domain Anda, Anda Mungkin Perlu Menunggu Beberapa Saat Agar Penyedia Layanan Domain Memperbarui Informasi Anda. Jika Setelah Beberapa Saat Masih Tidak Ada Respons, Silakan Coba Verifikasi Lagi, Atau Ganti Domain.",
  "4a5b7383d1": "Sedang memeriksa nama domain",
  "f24a492e40": "Catatan verifikasi, Anda dapat menutup halaman ini dan kembali lagi nanti.",
  "c697ca5f1a": "Selamat datang di versi perusahaan",
  "ebb01b1740": "berikutnya",
  "30109bf753": "Apakah perusahaan Anda memiliki nama domain?",
  "2b3e485b47": "Saya memiliki nama domain perusahaan",
  "1a7f5eae44": "Saya tidak memiliki nama domain perusahaan",
  "bde15d6d84": "Anda harus memiliki nama domain (misalnya, example.com) untuk membuat akun perusahaan Anda",
  "07ffb22c90": "Maaf, Anda harus memiliki nama domain untuk membuat akun perusahaan untuk perusahaan Anda",
  "de23836563": "Silakan masukkan nama domain yang digunakan untuk membuat akun perusahaan",
  "287c07944a": "Verifikasi nama domain Anda",
  "3ea2d528d5": "Ikuti langkah-langkah berikut untuk membuktikan bahwa Anda adalah pemilik <b>{domain}</b> dan mencegah orang lain menggunakan nama domain ini untuk mendaftarkan akun perusahaan.",
  "082b18ce56": "a. Buka situs penyedia layanan domain di <b>tab baru</b>, lalu <b>masuk</b> ke akun Anda;",
  "4f7e0841a9": "b. Di situs penyedia layanan domain, pergi ke <b>bagian catatan DNS</b>. Nama bagian catatan DNS di situs penyedia layanan domain Anda mungkin berbeda, seperti ditampilkan sebagai <b>DNS Management (Pengelolaan DNS), Name Server Management (Pengelolaan Server Nama), Control Panel (Panel Kontrol) atau Advanced Setting (Pengaturan Lanjut).</b>",
  "6365ad6e3a": "Selanjutnya, <b>kembali ke sini</b>, lalu klik 'Berikutnya' untuk menambahkan catatan verifikasi.",
  "8528892080": "Tambahkan catatan verifikasi",
  "7a225304f8": "a. Di halaman DNS, gulir ke bagian <b>TXT</b>, lalu klik tombol terkait untuk menambahkan catatan;",
  "b3cb7d947c": "b. <b>Salin dan tempel</b> semua nilai di bawah ini ke dalam <b>formulir TXT</b> situs penyedia layanan domain Anda;",
  "47213583bf": "c. <b>Simpan</b> catatan di situs penyedia hosting domain Anda, <br>lalu <b>kembali ke sini</b> dan klik \"Verifikasi Domain\" di bawah",
  "21486a57cf": "Perhatian: Di kolom Nama/Tuan Rumah/Alih Nama, Anda bisa memasukkan \"@\" atau membiarkannya kosong. Penyedia hosting domain Anda mungkin juga meminta Anda untuk memasukkan nama domain di kolom ini (<nama domain Anda>.com). Anda mungkin bisa merujuk pada catatan DNS lain untuk menentukan bagaimana mengisi kolom ini. Di kolom Masa Bertahan (TTL), masukkan \"86400\" atau biarkan nilai default.",
  "f1b8edab9c": "Ganti Domain",
  "7c6fc663a8": "Verifikasi Domain",
  "b6aee9dc0d": "Verifikasi Domain Berhasil",
  "dd4cc429ea": "Telah terbukti Anda adalah",
  "450f5c9230": "pemiliknya dan melarang orang lain menggunakan domain ini untuk mendaftar akun perusahaan.",
  "71cbcba755": "Klik \"Selanjutnya\" untuk menyelesaikan pembuatan akun perusahaan Anda.",
  "f4084f4870": "Silakan tetapkan akun masuk Anda",
  "fe3138baec": "Pembuatan selesai",
  "0315cddedb": "Pembuatan Perusahaan Berhasil",
  "91454a7f34": "Sekarang masuk ke panel administrasi untuk membuat akun perusahaan bagi anggota perusahaan Anda",
  "366304cde7": "1. Secara otomatis keluar dari akun WPS yang sedang login",
  "8a9f2a8422": "2. Anda perlu menggunakan akun perusahaan {account}@{domain} untuk masuk ke panel administrasi",
  "43e265e998": "Masuk ke panel administrasi",
  "9240efaaf0": "SMS telah dikirim",
  "e424bb9a6d": "Masukkan",
  "d44d581706": "Nama Perusahaan",
  "aa8679f406": "4 hingga 30 karakter",
  "581bdb1f98": "tidak boleh berisi simbol khusus \\ / : *? \" <> | {}",
  "c13cabb67a": "email:",
  "2b9b429e46": "Email Anda",
  "5ed834a7df": "Silakan masukkan email Anda",
  "acfd1f02ed": "Silakan masukkan email yang benar",
  "31c7c92cca": ", maksimal 80 karakter",
  "3f27cf84b3": "Masukkan kode verifikasi",
  "a0ae1f3ec4": "Kode verifikasi tidak benar",
  "e5589c5e74": "Nama Anda",
  "69d7bd63f6": ", hanya huruf, angka atau karakter Tionghoa",
  "91f008d258": ", maksimal 8 karakter",
  "6ea6c9b39b": "Telepon",
  "161042c5b7": "Masukkan nomor telepon",
  "e6b8eab1cd": "Masukkan nomor telepon, 11 digit",
  "3fd5fbb3cc": "Masukkan domain Anda",
  "cb5346ba8e": "Masukkan domain perusahaan yang benar, 4~30 karakter",
  "27928eb7a4": "Akun",
  "8e19bd444d": "Masukkan nama akun untuk login",
  "7bbbf479dc": "4-20 karakter, hanya angka, huruf, atau garis bawah",
  "3d84cae479": "Harap masukkan akun yang memenuhi persyaratan, karakter pertama harus berupa huruf atau angka",
  "c0d5ece1a7": "kata sandi",
  "f444036fa8": "Masukkan katasandi",
  "b03218d72b": "Kata sandi terdiri dari huruf besar kecil, angka, atau gabungan dari 3 kombinasi sepanjang 12-16 karakter",
  "b4ab05df50": "*Dalam unit Anda, seseorang telah menggunakan domain Anda untuk akun perusahaan. Silakan hubungi layanan pelanggan (400-677-5005) dan buktikan bahwa Anda memiliki hak kepemilikan atas domain ini",
  "c58876008f": "Gagal menyalin, harap coba lagi",
  "86f73420de": "Tautan Undangan",
  "a58861962c": "Maaf, browser Anda saat ini tidak mendukung untuk mengunduh kode QR ini",
  "228db07f78": "Departemen Keuangan, Departemen Penjualan, Manajemen Proyek, Data Bisnis, Departemen Produk, Operasi, Manajemen Riset dan Pengembangan, Rencana Versi, Departemen Layanan Pelanggan, Departemen Administratif, Departemen Pembelian, Manajemen Purna Jual",
  "93896d7e98": "Setelah membuat tim, mulailah berkolaborasi dengan rekan-rekan",
  "e8f66fb75c": "Departemen Keuangan, Departemen Penjualan, Manajemen Proyek/305, Administrasi SDM/306, Departemen Operasi, Manajemen Riset dan Pengembangan, Rencana Versi, Manajemen Layanan Pelanggan/403, Departemen Pembelian, Manajemen Purna Jual",
  "831b73da9b": "Nama tidak boleh mengandung karakter ilegal dan simbol khusus/\\;:*?\"<>|%&",
  "51ab33b3ee": "Parameter tidak benar",
  "a297f9e951": "Nama perusahaan duplikat",
  "04d60ed5f5": "Tidak dapat menggunakan istilah terlarang",
  "2ff7bef083": "Format domain salah",
  "41e1ba2165": "Gagal memverifikasi informasi TXT domain",
  "50f348caa9": "Akun duplikat",
  "9d4c950d65": "Nama ini telah terdaftar",
  "38cf19ed95": "Nama lembaga ini sudah ada",
  "4b426e7c9c": "Nama Lembaga",
  "298f880e18": "Sudah ada, kami sarankan Anda menambahkan lebih banyak informasi:",
  "1e67dd20b3": "Temukan nama lembaga",
  "517107cb04": "Gunakan nama lain",
  "5667081882": "Gunakan nama ini untuk membuat",
  "e306a979a6": "Isi cepat:",
  "f583db96e0": "*Jika nama institusi telah digunakan, Anda dapat",
  "9767148e34": "Masukkan nama perusahaan atau organisasi, 4~100 karakter",
  "e0e0ec159f": "Nama Lembaga",
  "5b13d254c0": "Nama perusahaan ini sudah ada",
  "92027671ec": "Nama Perusahaan",
  "36d482a7fb": "Temukan nama perusahaan",
  "79058a7577": "*Jika nama perusahaan telah digunakan, Anda dapat",
  "c96dd48dba": "Nama Perusahaan",
  "842efad336": "*Jika Anda adalah karyawan perusahaan, silakan",
  "860f9bd77b": "Layanan Pelanggan",
  "5a7ed18daf": "Bergabung dengan Perusahaan",
  "ab470e9ace": "Sediakan informasi kontak",
  "0a7e0e48a7": "Nama perusahaan yang diajukan untuk bergabung:",
  "a8dc318dcc": "Harap periksa informasi kontak yang Anda berikan, segera staf layanan pelanggan akan menghubungi Anda",
  "6ea1f4d7f5": "Kirimkan Dokumen",
  "d439e39f43": "Kami telah menerima dokumen Anda",
  "884653426b": "Customer service akan menelepon Anda dalam waktu 24 jam, harap perhatikan panggilan!",
  "2361cb14bf": "Pindai kode QR WeChat untuk menambahkan dukungan online dan memahami kemajuan",
  "50f45d0031": "Gagal menyimpan",
  "fc856d0fd2": "Super Administrator",
  "e16c0676d2": "Administrator",
  "b1d2ddd126": "Anggota Biasa",
  "9d322cc08d": "Nama institusi tidak boleh mengandung simbol khusus \\/:*?\"<>|{}",
  "b583ba7363": "Nama perusahaan tidak boleh mengandung simbol khusus \\/:*?\"<>|{}",
  "1d118a9bad": "Nama lembaga minimal 4 karakter, silakan masukkan nama lembaga antara 4~100 karakter",
  "441b45b1f5": "Nama perusahaan minimal 4 karakter, silakan masukkan nama perusahaan antara 4~100 karakter",
  "97457cb1f0": "Nama lembaga telah melebihi 100 karakter, silakan masukkan nama lembaga antara 4~100 karakter",
  "8ce00d3b92": "Nama perusahaan telah melebihi 100 karakter, silakan masukkan nama perusahaan antara 4~100 karakter",
  "a72778d3de": "Nama minimal 2 karakter, silakan masukkan nama antara 2~10 karakter",
  "79c17db5de": "Nama telah melebihi 10 karakter, silakan masukkan nama antara 2~10 karakter",
  "482a118202": "Nama hanya mendukung huruf Cina, angka, Huruf Latin, tanda titik",
  "9a9be18941": "Harap centang",
  "e6b7c4aa66": "Perjanjian Layanan Online",
  "595023d905": "Buat Institusi",
  "ba8c2df551": "Sembunyikan Lokasi Umum",
  "d284384975": "Perjanjian Layanan Online",
  "5c266d5a84": "Kebijakan privasi",
  "fcb92dbcf6": "Perjanjian Layanan Cloud Office",
  "2ae7a8a3f7": "Terima kasih telah memilih layanan WPS 365 Cloud Office. Berikut ini adalah perjanjian hukum antara Anda dan/atau organisasi yang Anda wakili dengan WPS Office terkait pendaftaran, langganan, dan penggunaan layanan ini.",
  "d30a6983bd": "Silakan membaca {0} | {1} | {2}, klik \"Setuju\", maka Anda dianggap setuju dengan isi perjanjian tersebut dan menerima layanan kami.",
  "263e306ede": "Saya telah membaca dan setuju {0} | {1} | {2}",
  "440129c0f1": "Silakan masukkan {0}",
  "8ab916983d": "Nama Perusahaan",
  "b01d68543b": "Nama Anda",
  "684b30d4e9": "Nomor Telepon Anda",
  "a48427e8e2": "Digunakan untuk membangun platform kerja perusahaan Anda",
  "3a81b0f1fc": "Memudahkan rekan kerja menemukan Anda dalam sistem untuk kerjasama",
  "52bc539b6e": "Konfirmasi Pembuatan",
  "b2fe245e19": "Buat Perusahaan/Tim: Berbagi dan Kolaborasi Dokumen",
  "893282d3f7": "Silakan lengkapi informasi perusahaan:",
  "cc997bf6aa": "Konfirmasi",
  "50fdde51ac": "{0}, {1}~{2} karakter",
  "a19cc5ec18": "{0}, tidak boleh mengandung simbol khusus \\u005C/:*?\"<>|{}",
  "26857f28f9": "{0}, hanya boleh memasukkan huruf, angka, dan karakter Tionghoa",
  "f4080b1431": "{0}, maksimal {1} karakter",
  "88e59b2d58": "{0}, 11 digit angka",
  "91d6d4e105": "Silakan masukkan kode verifikasi",
  "bec71bde96": "Kode verifikasi salah",
  "e20ff8ee19": "{0} harus diisi",
  "8dc09d10d7": "Tidak dapat menemukan dwId",
  "a03766ce6c": "Sekolah",
  "03542addfe": "perusahaan",
  "adb8a815d1": "Nomor telepon yang terikat dengan {0} telah mencapai batas",
  "97a6b66f1d": "Nomor telepon saat ini telah terikat dengan {0}",
  "665e465487": "Tidak dapat membuat {0}, nomor ponsel saat ini \"<strong>{1}</strong>\" telah mencapai batas maksimum {0} yang terikat (maksimal 5 {2} yang dapat diikat). Anda dapat masuk ke {3} yang telah terikat di bawah ini:",
  "a85b1367ca": "Nomor telepon saat ini \"{0}\" telah terhubung dengan {1}, Anda bisa memilih {2} yang sudah ada untuk masuk atau buat {3} baru:",
  "bf992ce17b": "Gunakan nomor telepon lain untuk membuat {0}",
  "395ea04444": "Buat {0} baru",
  "4ce3bb86b3": "Jumlah anggota {0} melebihi batas",
  "df88c4b7a5": "Nomor telepon saat ini \"{0}\" telah mencapai batas maksimal dengan {1}",
  "78f7dd59ca": "Nomor telepon saat ini \"{0}\" terhubung dengan {1} berikut, dapat langsung beralih menggunakannya",
  "8db491a3f8": "Lanjutkan membuat {0} baru",
  "83f6d9e1e4": "Coba lagi",
  "1dc5f11612": "atau",
  "217d76f53e": "Masukan",
  "b69a6ea62a": "Tahan tombol kiri mouse, gosok untuk mengungkapkan dua perisai",
  "3a31f64800": "Selamat Anda berhasil mengungkapkan perisai<br/>Lanjut ke langkah berikutnya",
  "6a81fcee96": "Memuat",
  "e97877a65d": "Wah, perisaikah hilang<br/>Silakan",
  "8d85456145": "Saya sudah menunggu terlalu lama<br/>Silakan",
  "77ad847b95": "Jaringan sungguh tidak baik<br/>Silakan",
  "dbd1ae3a34": "Anda menggosok terlalu cepat<br/>Silakan",
  "bd8e05cd53": "Klik tombol untuk memulai verifikasi pintar",
  "63d2a8a722": "Verifikasi berhasil",
  "73141928ad": "Verifikasi gagal, silakan klik tombol untuk menyegarkan",
  "04856c5c8a": "Deteksi pintar sedang berlangsung",
  "52cd9bd26d": "Tindakan Anda tidak diberi izin",
  "fd157e8ea8": "Panduan pembuatan",
  "c6225c5b2b": "Selamat datang menggunakan versi perusahaan",
  "e33423fb1e": "Pembuatan berhasil",
  "7b0c035999": "Halaman pembuatan perusahaan WPS Docs berhasil",
  "85db8faae0": "Panduan penggunaan versi perusahaan",
  "20591b9b44": "Temukan nama perusahaan",
  "b023d76dc2": "Panduan pengunggahan anggota",
  "e2f454e095": "Perusahaan {0}",
  "df466f942b": "Cabang",
  "26a7b797c4": "Pusat sub",
  "5fc82b360b": "Platform layanan perkantoran satu atap, membuat kerja Anda lebih efisien",
  "f2e736d52e": "Selamat datang menggunakan versi perusahaan",
  "becc41a35b": "Nama perusahaan",
  "74685cdc58": "Silakan masukkan nama perusahaan atau organisasi, 4~100 huruf",
  "07b55b1907": "Ukuran Perusahaan",
  "77b2f763ad": "Silakan pilih ukuran perusahaan Anda",
  "49d2509109": "Di bawah 5 orang",
  "8db2c9b74a": "6-20 orang",
  "a9fb0cf14a": "21-50 orang",
  "0fed41f8d3": "51-100 orang",
  "fb33f25a04": "101-200 orang",
  "3e3ff0f52e": "201-500 orang",
  "cd8b51f634": "501-2000 orang",
  "0662fa6eec": "Lebih dari 2000 orang",
  "69334dba1a": "Kebutuhan Perusahaan",
  "79994e749c": "(Kami akan merekomendasikan solusi praktik industri terbaik untuk perusahaan)",
  "840a017f38": "Silakan pilih masalah yang paling ingin Anda selesaikan",
  "f045b05c73": "Masukkan kebutuhan Anda dalam membuat perusahaan",
  "d8efb0b36d": "Lainnya",
  "adcb8fbb0c": "Nomor Telepon Umum",
  "eb1c73e2ca": "Silakan masukkan nomor telepon 11 digit yang sering Anda gunakan",
  "7f276e7dfa": "Buat Gratis",
  "c391b3eec1": "Gagal Mengirim Pesan",
  "54f4cb8fa7": "Pesan Terkirim",
  "231eb1fa1e": "Pengguna Bisnis {0}",
  "272b0f9d32": "Pengguna perusahaan",
  "b209a67331": "Gagal membuat perusahaan, silakan muat ulang halaman.",
  "acb08d0cc9": "Langkah Ketiga Membuat Perusahaan",
  "83db361f51": "Setelah pembuatan selesai, memicu logika pengalihan",
  "1e930326e3": "handleStep ke langkah berikutnya",
  "184df5c725": "saveForm gagal",
  "736eab3023": "Validasi Pengiriman",
  "2db62dc13c": "Validasi Gagal",
  "54fb0afaea": "Validasi Berhasil",
  "d39cff3fcf": "Lewati penyimpanan ekstrem hanya untuk mendapati bahwa verifikasi kode diperlukan",
  "305b777ae5": "Periksa nama gagal, buka dialog peringatan 'Nama Perusahaan Digunakan' dan simpan nama",
  "e57b6686b2": "Periksa apakah subjek autentikasi telah terverifikasi, buka dialog peringatan perlindungan autentikasi & simpan informasi subjek autentikasi terkait",
  "f7c86f496d": "Kode verifikasi kedaluwarsa atau nama duplikat - blokir eksekusi jika gagal verifikasi",
  "cb37db4fd4": "handleSubmit gagal",
  "243a569fc4": "Nama ini telah terdaftar, silakan gunakan nama lain",
  "196851a3d9": "Pengguna Bisnis {0}",
  "0c3a3595ff": "Pengguna perusahaan",
  "a33b41e0f2": "Gagal membuat perusahaan, silakan muat ulang halaman.",
  "fcce6a7156": "Berhasil Dibuat",
  "5ec6da58a6": "Beritahu Klien",
  "259c9dfa4e": "Logika Profesional",
  "864156930f": "Logika VBA",
  "7824efd172": "Docs Mobile",
  "52b6cfaaaf": "klien WPS",
  "c7c51beea9": "Edisi Pendidikan",
  "8d054d4986": "Antarmuka Default",
  "b597e18fb1": "isWps365PcClient dan memiliki openurl",
  "b0c13de2a0": "isWps365PcClient atau bukan client, memiliki openurl",
  "7d0f2ce18c": "isWps365PcClient atau bukan client, memiliki callback sukses openurl",
  "e2c5a07df6": "non-client non-openurl",
  "29e0414d1f": "panggilan balik non-client non-openurl",
  "60861f7d2a": "autoChange diserahkan ke pihak bisnis untuk beralih sendiri",
  "7c83140d90": "Status tamu dibuat, tidak perlu menggunakan sdk beralih akun (sdk tidak mendukung tamu), kode telah berhasil beralih antarmuka",
  "3379b09e59": "ada openurl dan menggunakan href untuk beralih",
  "586ff04c22": "beralih secara terpisah",
  "b6c91f218b": "gagal useSuccessSkip",
  "47d2f3ba66": "Lainnya",
  "57551f86ce": "Metode berbeda untuk memicu pengalihan berdasarkan utm_source",
  "64fe3758e2": "tindakan Anda tidak diotorisasi",
  "4da3e1262f": "Berhasil dibuat, mulai perjalanan kerja bisnis Anda",
  "c38dfb8c6c": "Buat Tim Pertama Anda",
  "38dddb483b": "Masuk ke Perusahaan",
  "614d9c91eb": "Undang anggota untuk bergabung",
  "97f1eca0aa": "Masuk ke Perusahaan",
  "13a4939e90": "Bergabunglah dengan Undangan Perusahaan",
  "a319e4ae0a": "Undang rekan untuk bergabung",
  "12e4da6bba": "Segera undang rekan",
  "bd885380f6": "Gagal mendapatkan tautan undangan",
  "5e626c4063": "SMS telah terkirim",
  "3dc09e7cfd": "Jumlah nama perusahaan yang Anda ajukan untuk pemulihan telah mencapai batas",
  "48318f41f9": "Undang anggota untuk bergabung",
  "45441baac4": "Ajak Anda bergabung {0} untuk berkolaborasi",
  "e5847fbd67": "Salin tautan, undang anggota",
  "23101dd40a": "Sedang disesuaikan solusi untuk Anda",
  "71bb7e54a8": "Manajemen Proyek",
  "aff37c79cc": "Coba solusi yang dipilih",
  "a97b174258": "Undang 2 rekan kerja lagi untuk bergabung dan dapatkan hak perusahaan gratis berikut",
  "253855849f": "Bagikan tautan undangan ke grup kerja undang rekan",
  "57b0a2a63f": "Salin tautan, undang rekan",
  "71c0a37ee1": "Masuk ke Perusahaan",
  "f848c60e0e": "Undang 2 rekan kerja lagi untuk bergabung dan dapatkan hak perusahaan gratis berikut",
  "664e32b4fe": "Halaman undangan Masuk ke perusahaan",
  "872f14403a": "Undang rekan untuk bergabung",
  "1880e7deb9": "Segera undang rekan",
  "cc2a9aaf82": "Berhasil dibuat",
  "02a13e2583": "Undang 2 rekan kerja lagi untuk bergabung dan dapatkan hak perusahaan gratis berikut",
  "5d3593cdce": "Gagal mendapatkan informasi tim",
  "c025113ea1": "Gagal mendapatkan tautan undangan",
  "b83bc1e485": "Tautan undangan",
  "0996ced9f6": "Maaf, browser Anda saat ini tidak mendukung untuk mengunduh kode QR ini",
  "1e88451e31": "Tautan undangan telah disalin",
  "bb969cabcd": "Penyalinan gagal, silakan coba lagi",
  "15e1f79c7a": "Ajukan bergabung ke perusahaan",
  "59c22b4ef8": "Menerima tautan undangan",
  "0f0b392e60": "Buat Tim Pertama Anda",
  "0437d07c43": "Nama Perusahaan",
  "41800c7bf1": "Masukkan nama pembuat",
  "1ec5999511": "Nama pembuat maksimal 8 karakter",
  "02da35b4e4": "Nama pembuat hanya dapat mengandung huruf, angka, atau karakter",
  "184e9f6616": "Masukkan nomor telepon",
  "9b587898ba": "Masukkan nomor telepon dalam format yang benar",
  "e68c164a02": "Masukkan email Anda",
  "0b1de22df7": "Masukkan email dalam format yang benar",
  "61026181ab": "Lisensi usaha wajib diisi",
  "c3847e604e": "Ukuran file melebihi 10M, silakan pilih lagi",
  "49450f4ec7": "Formulir pengaduan untuk nama yang sama wajib diisi",
  "39c3b8fa1d": "Pengiriman gagal",
  "3ea44d7963": "Unggahan berhasil",
  "5b1aa3c2c4": "Pengunggahan gagal.",
  "7e7f81eaa3": "Unggahan gagal, file lebih dari 10m",
  "2ff1913de1": "Unggahan gagal, file harus .jpg, .jpeg, .png, .bmp, .pdf",
  "7951a879f2": "Lisensi usaha wajib diisi",
  "66bda65057": "Ukuran file melebihi 10M, silakan pilih lagi",
  "8f2305a83d": "Formulir pengaduan untuk nama yang sama wajib diisi",
  "55ff0c8c6e": "Pengiriman gagal",
  "8dad6d950d": "Gagal mendapatkan informasi undangan",
  "a5f0ac3a9a": "Pembuatan Berhasil",
  "4f1d069770": "Parameter utm pada halaman undangan adalah {0} dan nama {1}",
  "f9578cfe6d": "Parameter utm untuk panduan dua langkah adalah {0} dan nama {1}",
  "e10d028405": "Panduan Dua Langkah Pcoffice Dibuat",
  "8e22e4fcc4": "Tautan undangan telah disalin",
  "3f327f9f37": "Salin gagal, silakan coba lagi",
  "bd1aecb265": "Batal",
  "b6abf9b19a": "Setuju",
  "e910d9cc0f": "Batal",
  "37ab25522d": "Setuju",
  "196b3eb9cf": "Pindai kode untuk bergabung",
  "2b81c52e20": "Unduh gambar",
  "62152fd9f3": "Undangan tautan",
  "e0a3725651": "Maaf, browser Anda saat ini tidak mendukung pengunduhan kode QR ini",
  "8b7883b2c7": "Pindai kode untuk bergabung",
  "9e9a659ed5": "Unduh gambar",
  "0d55065a9a": "Undangan tautan",
  "487cf6a106": "Maaf, browser Anda saat ini tidak mendukung pengunduhan kode QR ini",
  "78fd005d1f": "Masukkan nomor telepon",
  "f909563857": "Gunakan nomor ini untuk membuat",
  "a26a19f139": "Batalkan Pembuatan",
  "cc004ac9ee": "Nomor Telepon",
  "4df8c3c588": "Masukkan nomor telepon lain untuk membuat sekolah",
  "3151cabb3d": "Masukkan nomor telepon lain untuk membuat perusahaan",
  "56098a71eb": "Klik Verifikasi Cerdas, kirim kode verifikasi",
  "e96ec218e4": "Masukkan kode verifikasi SMS",
  "ce619a0225": "Kode verifikasi SMS telah dikirim ke",
  "0e9863aaeb": "Kode verifikasi salah, silakan masukkan lagi",
  "32dc8629e1": "detik untuk mengirim ulang",
  "e4eda9add5": "Kirim Lagi",
  "b007977564": "Gagal mendapatkan informasi persetujuan",
  "d8852ffc9c": "Akses bukan dari admin",
  "8a733a2574": "Akses dari perangkat bergerak",
  "9e8c152c4f": "Akses dari perangkat PC",
  "2265a55e93": "Setuju Dengan Perjanjian Layanan",
  "80dabe5aa3": "Panduan Membuat",
  "7deee8bf5a": "Dua Langkah Panduan DocsWeb Dibuat",
  "69eb501ecb": "Permohonan Anda telah kadaluwarsa, tidak dapat diakses",
  "aa1d9d98ad": "Akses tidak memadai, tidak dapat diakses",
  "fdf2fe129e": "Buat Organisasi",
  "7f0ca0df6b": "Sembunyikan Lokasi Umum",
  "cc6ac2a93c": "Panduan Dua Langkah Base Dipasang",
  "5d6c570bf0": "Panduan Dua Langkah sebelum unload",
  "a4eb8a192d": "Tim yang semua orang buat",
  "4912e16a9d": "Nama perusahaan telah dipulihkan",
  "41c4e87ef2": "Anda dapat mengklik tautan",
  "5e630930c0": "Buat ulang perusahaan",
  "436a563524": "Jika Anda sudah membuat perusahaan, Anda dapat merujuk",
  "0b6e7cbe7f": "'Bagaimana Cara Mengubah Nama Perusahaan'",
  "cb7bce0775": "Panduan untuk Mengubah Nama Perusahaan",
  "3feadd3040": "Versi saat ini terlalu rendah, tidak dapat menggunakan perusahaan",
  "3cf23de936": "Versi perangkat lunak Anda terlalu rendah, fitur perusahaan tidak dapat digunakan. Silakan pergi ke pasar aplikasi untuk memperbarui versi perangkat lunak!",
  "a1c5d5d202": "Ok",
  "e50183bd00": "WPS Cloud",
  "e5031ab679": "Aman, Sinkronisasi, Kolaborasi",
  "c870026dfc": "Akses masuk Wechat",
  "e7647cd875": "Akses masuk akun Wps",
  "07b380074b": "Akses masuk QQ",
  "67921724dd": "Cara lain",
  "254da8a9f5": "Jumlah bergabung/membuat perusahaan telah mencapai batas",
  "3648e4811b": "Masuk ke Docs",
  "dcd102b346": "Buat Tim Kustom",
  "8b9b258cbf": "Masukkan Nama Tim Di sini",
  "19bb6e0ded": "Hak istimewa WPS Anggota",
  "2d9fe8d938": "Fitur kantor untuk membantu Anda memecahkan masalah dokumen sehari-hari, datang dan coba!",
  "e8c1caa649": "Unggah dari Lokasi",
  "03641083a3": "Pindahkan dari 'Dokumen Pribadi'",
  "eecd3ab9b5": "Lain kali",
  "13b447b3a8": "Ganti",
  "3c2fc507fc": "Versi saat ini terlalu rendah, tidak dapat menggunakan perusahaan",
  "c3615d8134": "Versi perangkat lunak Anda terlalu rendah, fitur perusahaan tidak dapat digunakan. Silakan kunjungi situs web resmi untuk memperbarui versi perangkat lunak!",
  "644a36e05b": "Perbarui",
  "d435105f21": "Jumlah bergabung/membuat perusahaan telah mencapai batas",
  "73a286ceb0": "Masuk ke Docs",
  "c2cec645c0": "Batal",
  "b5f5b83c0f": "Setuju",
  "76ec352da5": "Pindai kode undangan untuk rekan kerja",
  "6a509e4487": "Unduh kode QR",
  "940cc4a546": "Tidak dapat membuat perusahaan",
  "78b2a62ea5": "Masuk ke perusahaan yang ada atau buat perusahaan baru",
  "3a6da7f6f9": "Jumlah perusahaan yang terkait dengan nomor telepon saat ini telah mencapai batas (dapat mengikat maksimal 5 perusahaan)",
  "93bab52870": "Nomor telepon saat ini telah terhubung dengan perusahaan, Anda dapat memilih untuk masuk ke perusahaan yang sudah ada:",
  "ce6e0adaf2": "Anda dapat memilih untuk masuk ke perusahaan yang terhubung di bawah ini:",
  "1ce200a92b": "Pilih",
  "bb91ef2999": "Buat Perusahaan Baru",
  "024e4a91e5": "Nama perusahaan telah terdaftar sudah digunakan",
  "eb089a23a0": "Nama perusahaan ini telah terdaftar di gunakan:",
  "7646558701": "Administrator:",
  "1d9c02bd33": "Waktu Daftar:",
  "919fc7805f": "Disarankan agar Anda mencoba mencari, menghubungi rekan kerja di atas.",
  "0ca71a9344": "Anda juga dapat sementara menggunakan nama lain untuk membuat perusahaan (dapat diubah nanti), kemudian mengajukan permohonan.",
  "e83a244e90": "Klik untuk mengetahui cara pengajuan banding.",
  "d22bedfb21": "OK",
  "907b78b6e5": "Masukkan nama kelompok kerja atau tim",
  "7195b0ac1e": "Tim yang mungkin ingin Anda buat",
  "60ed4f915e": "berikutnya",
  "f5ba8dfb7b": "Lewati Panduan",
  "5c44a3ef68": "Maksimal 100 karakter",
  "130c53fb20": "Nama tidak boleh mengandung karakter ilegal dan simbol khusus /\\;:*?\"<>|%&",
  "e832d41acc": "Panduan Dua Langkah Lewati",
  "80d9cf7177": "Panduan Dua Langkah Segarkan",
  "0aebf80435": "Panduan Dua Langkah Klik label",
  "e74f515977": "Panduan Dua Langkah handleSubmit",
  "308d2a53c9": "Panduan Dua Langkah createGroup",
  "dda2ed7e18": "Panduan Dua Langkah Gagal Membuat Tim",
  "ded3c35500": "Gagal Membuat Tim",
  "4f18031bc1": "Panduan Dua Langkah createTemplate",
  "091e5cefcc": "kesalahan createTemplate dua langkah",
  "58cf4e00f0": "Kode verifikasi",
  "92abbf0385": "Kirim Kode Verifikasi",
  "f0f9976ef9": "Silakan masukkan nomor ponsel",
  "a4ce99b1df": "Kode verifikasi",
  "39d36e0f9f": "Konfirmasi",
  "0fd8a01938": "Kirim",
  "9048a4e842": "Nomor Ponsel",
  "9afa1091eb": "Kirim Ulang",
  "58d787001f": "Masukkan nomor ponsel lain untuk membuat sekolah",
  "450905a265": "Masukkan nomor ponsel lain untuk membuat perusahaan",
  "f7386de3c6": "Pilih dari menu turun",
  "27aa05a92c": "Setujui Perjanjian Layanan",
  "80af61cb57": "Kembali ke Halaman Sebelumnya",
  "50149b8d4f": "Nama Pemohon",
  "e6756f8749": "Masukkan nama Anda",
  "3cbd51a2b1": "Nama minimal 2 karakter, silakan masukkan nama 2-10 karakter",
  "4f79b4813f": "Nama hanya mendukung karakter Cina, angka, huruf, dan titik",
  "71d3e75983": "Nomor Ponsel yang Sering Digunakan",
  "afe5149035": "Silakan masukkan nomor ponsel yang sering Anda gunakan",
  "1e9270b50f": "Silakan masukkan nomor ponsel yang sering Anda gunakan, 11 digit",
  "ff5dc98dfb": "Lewati",
  "165be2ab43": "Kembali ke Langkah Sebelumnya",
  "231d8a335a": "Setujui Perjanjian Layanan",
  "1cad008ffc": "Nama perusahaan{0} telah terdaftar, silakan gunakan nama lain",
  "c6e274fcab": "Konfirmasi Perjanjian",
  "b9352504bb": "Tutup pop-up perjanjian",
  "8409e99ad0": "Buka pop-up perjanjian",
  "1593c6dd95": "Kirim",
  "4f44a9de22": "Buka verifikasi pesan",
  "26b70c68b8": "Lewati, langsung masuk ke perusahaan",
  "a8bebcb302": "Kembali ke Halaman Sebelumnya",
  "c800b4fec5": "Halaman undangan Base Mounted",
  "38b396d5b0": "Halaman undangan docsWeb Mounted",
  "2eb7f9a9f1": "Banding Anda telah berhasil diajukan",
  "2c6f3590fb": "Kami akan mengirimkan hasil proses ke email Anda dalam waktu 3 hari kerja",
  "2ea3eff708": ". Harap periksa email Anda.",
  "53acfba22c": "Undang kolega segera",
  "4e6d282f4f": "Bergabung dengan undangan perusahaan",
  "5f72f4b936": "Undang kolega segera",
  "e5383077ba": "Temukan Nama Perusahaan",
  "06e3fa2350": "Setelah Penelusuran,",
  "653a263b5e": "Pencipta",
  "769f57269f": "Nomor Telepon Penciptaan Adalah",
  "09a224695e": "Silakan konfirmasi apakah pembuat perusahaan ini adalah rekan kerja Anda",
  "3beda6c149": "Jika itu rekan kerja Anda, Anda dapat menghubungi dia",
  "5c74dd10d1": "Ubah Nama Perusahaan atau Pindahkan Super Administrator.",
  "da504edb0f": "Jika bukan rekan kerja Anda, Anda dapat mengklik tombol di bawah untuk melanjutkan mengembalikan nama perusahaan.",
  "39194faaf1": "Lanjutkan Pemulihan Nama Perusahaan",
  "e22b829e90": "Berhasil disalin",
  "6e1b44752a": "TXT nilai",
  "79881b1d7a": "Segera Undang Rekan Kerja",
  "a5344a45f9": "Klik di pojok kanan atas, pilih \"Kirim ke Teman\"",
  "a4954a5b08": "Segera Undang Rekan Kerja",
  "8e3a1625fb": "Temukan Nama Perusahaan",
  "bf8b8c7005": "Unggah Akta Pendirian Perusahaan",
  "bfd44a66c9": "Klik Pilih",
  "d503f20925": "Silakan unggah salinan atau foto izin usaha perusahaan.",
  "cbebe043c5": "Mendukung format JPG, JPEG, PNG, BMP, PDF, dengan ukuran tidak lebih dari 10 MB.",
  "9650b96d7d": "Unggah Formulir Banding Nama yang Sama",
  "c3b8ae46d3": "Silakan unggah berkas atau foto pindaian formulir permohonan banding nama duplikat.",
  "9e325a9e09": "Unduh Template Tabel Informasi",
  "a4711aae88": "Kirimkan aplikasi",
  "3a5cc1441e": "Verifikasi...",
  "0bd7bf8511": "Saat ini kami tidak dapat memverifikasi domain Anda, Anda mungkin perlu menunggu beberapa waktu agar penyedia layanan hosting domain memperbarui informasi Anda. Jika tidak ada hasil setelah beberapa waktu, silakan coba verifikasi lagi, atau ganti domain.",
  "fae48d554b": "Memeriksa Nama Domain",
  "5e1779a0ca": "Riwayat verifikasi Anda dapat menutup halaman ini dan kembali lagi nanti untuk memeriksanya.",
  "ca85f8b836": "Selamat datang di Versi Perusahaan",
  "2570e0f00b": "Gagal masuk",
  "40d16a007e": "Akun Anda telah terhubung secara otomatis",
  "81376b92e4": "Silakan masuk kembali menggunakan akun perusahaan untuk cara masuk {0}.",
  "ba679ba739": "Masuk",
  "c05f64c6c6": "{0} akan secara otomatis beralih ke login",
  "c329ccef3a": "Gagal masuk",
  "e370f9afb1": "Akun Anda telah terhubung secara otomatis",
  "410cf42585": "Silakan masuk kembali untuk beralih ke akun perusahaan.",
  "062d48aece": "Masuk",
  "95a105d412": "Setelah otomatis masuk ke halaman login",
  "2d000d5a6d": "Mengirim Tautan Berbagi ke Anggota, Anggota Dapat Membuka dan Meminta Bergabung",
  "8861b6e90d": "Masuk Perusahaan",
  "25b9f72fda": "Kesalahan Parameter Halaman",
  "1c76123efc": "Gagal Mendapatkan Tautan Undangan",
  "6caba48b76": "Lewati",
  "f66379c650": "Kesalahan Parameter Halaman",
  "c45021de2a": "Gagal dibuat.",
  "011d470126": "Platform terus melindungi keamanan informasi Anda",
  "f1a44d9151": "Platform telah menerima sertifikat ISO27001, ISO27701 yang dikeluarkan oleh BSI internasional, dan lulus penilaian kualifikasi keamanan tingkat tiga nasional.",
  "255ea5dff7": "Kertas Putih Keamanan",
  "bb55b124f2": "Buat Presentasi Perusahaan",
  "61e24974a3": "Buat Konten Strategi Akuisisi Perusahaan",
  "bfdf78febe": "Langkah Berikutnya Selesaikan Data",
  "c4aa2d2d60": "Masukkan Nama Grup Kerja atau Proyek",
  "b69765ab64": "Tim yang Sedang Dibuat Semua Orang",
  "9657d9408b": "Ganti",
  "e21da8c16a": "berikutnya",
  "224ef5cc9f": "Lewati Panduan",
  "641f58c8f6": "Perusahaan Saat Ini Tidak Mendukung Anggota Membuat Tim, Silakan Minta Administrator Membuat",
  "efea622752": "Salin Tautan, Undang Rekan",
  "fd5b40a9fd": "Mengundang Anda Bergabung dengan \"{0}\", Bekerja Sama",
  "b04dd2f10a": "Tautan Undangan Telah Disalin",
  "d1606a1b1a": "Penyalinan Gagal, Silakan Coba Lagi",
  "0d59f3db83": "Masukkan Departemen atau Tim Proyek, Contoh \"Departemen Penjualan\"",
  "9429513d34": "Panduan Tidak Diperlukan",
  "b54a20b1ff": "Gagal dibuat.",
  "093fa0fb74": "Otorisasi Masuk...",
  "b383b136f4": "Inisialisasi Proyek Perusahaan",
  "b6b21b388b": "Nama Perusahaan Sudah Terdaftar",
  "285dc68c10": "Nama Perusahaan Ini Sudah Terdaftar:",
  "1bf685b89d": "Administrator:",
  "7b4297edcc": "Waktu Registrasi:",
  "fa51ea19fc": "Sarankan Anda Mencoba Mencari, Menghubungi Rekan Anda yang Disebutkan.",
  "e3678a996d": "Anda Juga Dapat Menggunakan Nama Lain Sementara untuk Membuat Perusahaan (Dapat Diubah Nanti), Lalu Ajukan Banding.",
  "5969bc8071": "Baiklah",
  "ba4cf699df": "Temukan Nama Perusahaan",
  "afecee4eb4": "Nama Anda",
  "a8bdebc614": "Silakan Masukkan Nama Anda",
  "5bbeb38a66": "Telepon",
  "b4f7b44b7a": "Silakan Masukkan Nomor Telepon Anda",
  "cac2913686": "Email Kontak",
  "23d3bb3a42": "Silakan Masukkan Email Kontak Anda",
  "ea106a393c": "Unggah Surat Izin Usaha Perusahaan",
  "f74131d71e": "Klik Pilih",
  "53749c51c5": "Silakan Unggah Scan Atau Foto Surat Izin Usaha Perusahaan",
  "c00f2ea171": "Dukungan Format JPG, JPEG, PNG, BMP, PDF, Ukuran Tidak Melebihi 10 MB.",
  "57ec07fa97": "Unggah Formulir Banding Nama Ganda",
  "8eb0606e94": "Silakan Unggah Scan Atau Foto Formulir Banding Nama Ganda",
  "f59e76c0b0": "Unduh Template Formulir Informasi",
  "030bd26fa4": "Ajukan Aplikasi",
  "0a602dc727": "Penyimpanan Data Aman",
  "9138f28acf": "Berbagi File dan Kerja Sama",
  "b3a306cf90": "Kepatuhan Legal",
  "973c53f725": "Sarankan Memodifikasi Nama, Setelah Registrasi Dapat Mengajukan Sertifikasi Lembaga dan Memperbarui Nama",
  "f886f5e92f": "Sarankan Memodifikasi Nama, Setelah Registrasi Dapat Mengajukan Sertifikasi Perusahaan dan Memperbarui Nama",
  "b8051702a3": "Nama Ini Mengandung Kata Sensitif, Silakan Sesuaikan Nama atau Hubungi Staf Layanan Pelanggan",
  "d73881f7d4": "Nama Perusahaan Dilindungi",
  "dc7e58e320": "Nama Perusahaan Dilindungi, Verifikasi Informasi Utama Diperlukan sebelum Digunakan. Sarankan Memodifikasi Nama Perusahaan, atau Gunakan Nama Ini Setelah Registrasi dan Sertifikasi Perusahaan.",
  "20c3bc070c": "Konfirmasi",
  "c4278e5f28": "Hak Tidak Cukup",
  "9217efae21": "Akun Anda yang masuk belum memiliki izin untuk membuat, silakan hubungi tenaga penjualan untuk penanganan",
  "52ff08f2ad": "Nama lembaga dilindungi, silakan sesuaikan nama perusahaan",
  "79386ae280": "Masukkan kode verifikasi 6 digit",
  "d7b2c5a41b": "Kode verifikasi telah dikirim ke",
  "ce2e1c26f7": "(Berlaku dalam 10 menit)",
  "59d338903f": "{0} detik lagi bisa mendapatkan kode verifikasi lagi",
  "5aadd14136": "Dapatkan Kode Verifikasi Lagi",
  "90f5c93432": "Nama ini sudah terdaftar",
  "1677072f4a": "Anda dapat melengkapi informasi lebih lanjut, atau menggunakan nama lain untuk mendaftar",
  "3b8459fb1e": "Isi Cepat:",
  "6f38edbcb1": "Gunakan Nama Ini Untuk Mendaftar",
  "8406c81e2d": "Cabang",
  "29d323fa85": "Subcenter",
  "4f0e806e02": "Bagian Keuangan",
  "3f935efb6b": "Setuju dengan Perjanjian Layanan",
  "b42241be05": "Nanti",
  "99de4b33b7": "Setuju",
  "7f867e7395": "Gunakan Nomor Ponsel Lain untuk Membuat Perusahaan",
  "0d51a8f7a6": "Lanjutkan Pembuatan",
  "8bdaecf2e5": "Masukkan nomor ponsel anda",
  "565ae60c8a": "Masukkan nama anda",
  "f76e06d0e7": "Masukkan nomor ponsel anda",
  "7b0fca5255": "Masukkan kode verifikasi",
  "68026d2d25": "Selamat datang di versi perusahaan",
  "d25b5541be": "Buat Gratis",
  "32cfd73733": "Masukkan nama tim, perusahaan, atau organisasi",
  "4cf83dc4a0": "Pembuatan cepat satu menit, bekerjasama dengan rekan kerja secara efisien",
  "d320d37116": "Buat tim/perusahaan gratis",
  "c54b475dd2": "Perjanjian Pengguna",
  "190d54e616": "Perusahaan {0}",
  "8c1b768ac4": "Verifikasi Cerdas Gagal",
  "d74eab0f35": "Informasi nama perusahaan yang Anda isi tidak sesuai dengan standar platform, silakan modifikasi dan coba lagi",
  "0f3d62dd4f": "Informasi nama Anda tidak sesuai dengan standar platform, silakan modifikasi dan coba lagi",
  "647cf2211b": "Nomor ponsel saat ini tidak mendukung pembuatan, silakan ganti nomor ponsel",
  "b63d96cdae": "Informasi yang dibutuhkan tidak memenuhi standar platform, silakan modifikasi dan coba lagi",
  "2dbbe8e43f": "Nomor ponsel saat ini tidak mendukung pembuatan, silakan ganti nomor ponsel",
  "b18abc5de6": "Tidak Ada Nomor Ponsel yang Terikat",
  "f5233dae6f": "Silakan ganti nomor ponsel untuk membuat",
  "4167c8b88d": "Nomor ponsel saat ini mungkin memiliki situasi berikut, silakan coba ganti nomor ponsel untuk membuat. Jika ada pertanyaan, silakan hubungi layanan pelanggan.",
  "a8a2433c4d": "Hapus dan tambah WeChat, konsultasi dengan layanan pelanggan",
  "444a639c09": "Saya mengerti",
  "69a097057f": "Nomor ponsel saat ini termasuk dalam segment operator virtual <#BB2726>",
  "4370b06fd0": "Nomor ponsel saat ini memiliki perilaku penggunaan <#BB2726> yang tidak normal",
  "8c49e1dc4a": "Perlu melakukan verifikasi manusia-mesin",
  "4b8ba7d8cc": "Platform Produktivitas Baru",
  "81be771e17": "Perusahaan Berhasil Dibuat! Lengkapi informasi untuk mendapatkan layanan eksklusif",
  "461125b057": "Dapat mengelola dokumen dan data dalam tim. Anggota tim dapat dengan mudah melihat dan juga mengatur izin edit/unduh, memastikan keamanan data",
  "c3eb25029b": "Ukuran perusahaan/tim yang Anda masuki",
  "049f8401ec": "Di bawah 5 orang",
  "c81896349e": "6-20 orang",
  "7357daac4e": "21-50 orang",
  "f0e65a0a29": "51-100 orang",
  "b9fac8204a": "101-200 orang",
  "62d73dddaf": "201-500 orang",
  "3bcdaf7160": "501-2000 orang",
  "ab0b2333fe": "Lebih dari 2000 orang",
  "4f756eedc8": "Peran Anda adalah",
  "3ba0b502c3": "General Manager",
  "702099cc72": "Keuangan",
  "843b603162": "Pengadaan",
  "8b414a9b44": "Personalia/Administrasi",
  "92486b2908": "Penjualan",
  "ac4e7fb063": "Apakah organisasi Anda memiliki anggaran/paket pembelian perangkat lunak kantor",
  "37634c72dc": "Dalam waktu setengah tahun",
  "bd94b6deec": "Dalam waktu 1 tahun",
  "713f4aad5c": "Sedang dipertimbangkan",
  "c5ea095a4d": "Belum ada rencana",
  "2409099a69": "<img src=\"https://ks3-wpsplus-prod.wpscdn.cn/e2546275-3953-40b4-8933-9ff6f0a1aeb4.png\"> Buat Tim, Ajak Anggota Bergabung untuk Bekerja Sama",
  "9d27dc2d90": "Dapat memasukkan nama tim atau proyek yang baru-baru ini diamati",
  "de19c8509a": "Anda mungkin ingin membuat:",
  "1a84699223": "Departemen Penjualan",
  "efab59502b": "Departemen Produk",
  "7e599b3713": "Departemen Operasional Selatan",
  "bf494779c2": "Departemen Pengadaan",
  "f3a60ab34d": "Bagian Admin",
  "bbc50c1ac8": "Departemen Keuangan Utara",
  "32629e3dac": "Departemen Keuangan Produk",
  "5524d354ba": "Departemen IT",
  "0ccda29a0d": "🎁<span style='color: rgb(206,131,62);'>Anda Telah Membuka Manfaat Pemula!</span> Ajak 3 Orang Lagi untuk Mendapatkan <span style='color: rgb(206,131,62);'>4T Ruang Penyimpanan, WPS AI</span>",
  "939eb98492": "<span style='color: rgb(206,131,62);'>Anda Telah Membuka Batas Maksimum 50 Orang, Upload File Maksimum 4G</span>. Ajak 3 Orang Lagi untuk Membuka Manfaat Hebat 30 Hari WPS AI, 4T Ruang Penyimpanan",
  "136c26d941": "Salin tautan di bawah untuk mengundang anggota bergabung",
  "3de5c12558": "Salin tautan, undang rekan kerja",
  "a5d64b14f3": "Panduan informasi perusahaan",
  "b8f2492701": "Pengumpulan informasi perusahaan",
  "1f9d053dc0": "Buat template tim",
  "0e83c79a88": "Undang Anggota",
  "821fc1906a": "Masuk perusahaan",
  "463e14ae9c": "Silakan pilih tim",
  "690f0cdb9e": "Ikon selesai",
  "c340522a17": "Sebelumnya",
  "f9355c72ef": "Lewati",
  "bd6c09ebbb": "berikutnya",
  "2a2603cd3f": "Pindai kode untuk mengirimkan undangan kepada rekan kerja",
  "411e64907a": "Salin",
  "b0d988cf23": "Unduh",
  "e3c0b650ac": "Berhasil disalin",
  "713ac624b4": "Selamat datang di WPS 365",
  "b8fff97849": "Elemen target tidak valid",
  "02acdcf296": "Konversi html2canvas gagal, tidak menghasilkan canvas",
  "a76988c496": "Konversi canvas ke blob gagal",
  "af89584edf": "API clipboard tidak tersedia",
  "f90263bbde": "Menyalin gambar gagal",
  "71b05319da": "Konversi html ke canvas gagal",
  "38852999fe": "Menyimpan informasi gagal",
  "4a4c621d07": "Gagal Membuat Tim, Silakan Coba Lagi Nanti",
  "d239a23994": "Halaman ini hanya dapat diakses dengan akun perusahaan, Silakan masuk dengan akun perusahaan terlebih dahulu.",
  "d93bfb7fb9": "Masukkan isi",
  "42b81a66c4": "Panjang antara 2 sampai 100 karakter",
  "76d33733db": "Tidak boleh mengandung karakter khusus seperti / \\ ; : * ? \" < > | % &",
  "dc55d1f62f": "Mulai Mengalami",
  "b25233cba0": "Kolaborasi Dokumen + Komunikasi Instan, Memulai Cara Baru Bekerja Dengan Efisien",
  "f0e563652d": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Memulai Obrolan Grup Kolaboratif, Berbagi Dokumen dengan Aman dan Nyaman",
  "1e484cce68": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/lingxi_normal.png\"> Asisten AI Lingxi, Asisten Cerdas yang Dibuat Khusus untuk Perkantoran",
  "e338385bc9": "Office Cerdas Alami, Terintegerasi Mendalam dengan AI dan Perangkat Lunak Kantor, Membuat Setiap Orang Memiliki Asisten AI",
  "7ae1f3b1c6": "Impor File/Folder Selesai, Bisa Dilihat di \"AirPage Saya\"",
  "85db2a024a": "Impor File/Folder Gagal, Silakan Coba Lagi Nanti",
  "9ff74c802a": "Unduh Versi Chip Intel",
  "ab44928f02": "Unduh Versi Chip Apple",
  "a08d937c38": "Mengunggah File/Folder, Setelah Selesai Dapat Dilihat di \"AirPage Saya\"",
  "68db1829fa": "Hanya Mendukung Impor dari Akun Pribadi, Silakan Masuk ke Akun Pribadi lalu Coba Lagi.",
  "1185a7c7ab": "Di Bawah 20 Orang",
  "e2bcc252c9": "21-300 Orang",
  "3c4842f1ea": "301-1000 Orang",
  "1bbee64cfa": "Di Atas 1000 Orang",
  "388ff4a035": "Pengajar",
  "d341b1d794": "Siswa",
  "bfb2ee4148": "Lainnya",
  "f6450c3f31": "Manajemen Proyek",
  "b87fd33a0d": "Rencana Tahunan",
  "0dd45a1c14": "Manajemen Kinerja Karyawan",
  "67fa01cac6": "Kegiatan Pemasaran",
  "6dd82cc031": "Perekrutan Karyawan",
  "a7edaed91d": "Bahan Ajar",
  "bf12b7efb0": "Manajemen Rencana Pengajaran",
  "c35ae8f358": "Dokumen Produk",
  "343f236a78": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/dbsheet.png\"> WPS Tabel Multidimensi, Visualisasi Pembangunan Sistem Bisnis Eksklusif",
  "72286d5519": "👏Rekomendasi Template",
  "0bc00ee949": "Manajemen Kekurangan Kebutuhan",
  "e22f3d56f7": "Manajemen Kreasi Konten",
  "dd439de3dd": "Sistem Manajemen Pelanggan",
  "fbb2bbf82e": "Rencana Persiapan Ujian",
  "0645b908bc": "Pencarian Gaji",
  "813b3d3d7e": "Manajemen OKR",
  "918e33d5bd": "Buat dengan Satu Klik",
  "ebf9cfb7ef": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/import_files.png\"> Impor Dokumen Umum, Lebih Nyaman",
  "c58f28713c": "Impor dari Lokal",
  "9d6a0a4370": "Mendukung Format File Office yang Umum",
  "54c48aee85": "Pilih Berkas",
  "c5b593e452": "Impor dari Akun Pribadi",
  "4bdcd9d4c5": "Impor Satu Klik Dokumen Akun Pribadi, Tim, Folder",
  "99b2968905": "Impor Otorisasi",
  "472f818a23": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Unduh Klien WPS Teams",
  "fe46574227": "Kolaborasi Dokumen + Komunikasi Instan, Cara Efisien untuk Bekerja",
  "beefe5a09b": "Download sekarang",
  "278839c7b1": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Pengaturan Keamanan Beragam, Menjamin Keamanan Data",
  "b4e70dbeab": "Pengalaman Berbasis Keamanan Dokumen WPS selama Bertahun-tahun, Melindungi Data Penting Perusahaan dari Kebocoran",
  "42dc772619": "File Terlalu Besar, Silakan Coba Impor di Beranda Nanti",
  "a052564e47": "Kesalahan Pembuatan, Silakan Coba Lagi Nanti",
  "790d0c428c": "Masuk Ke Dasbor"
}